import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  scrollToTopButton: {
    position: "fixed",
    right: "30px",
    padding: "10px 15px",
    fontSize: "16px",
    borderRadius: "50%",
    backgroundColor: theme.palette.MDCColors.color23,
    color: "#fff",
    border: "none",
    cursor: "pointer",
    boxShadow: "0px 2px 8px rgba(0,0,0,0.3)",
    zIndex: 1000,
  },
}));

const ScrollToTopButton = () => {
  const [visible, setVisible] = React.useState(false);
  const { scrollToTopButton } = useStyles();

  useEffect(() => {
    const handScroll = () => {
      if (window.scrollY > 300) {
        setVisible(true);
        const jsdWidget = document.querySelector('[id="jsd-widget"]');

        const scrollToTop = document.querySelector(
          "[id='scroll-to-top-button']"
        );

        const vorgangeListTable = document.querySelector(
          '[id="vorgangeListTable"]'
        );

        const helpCenterButton = document.getElementById("help-center-button");

        if (!jsdWidget) {
          if (helpCenterButton) {
            vorgangeListTable &&
              (vorgangeListTable.style.marginBottom = "7rem");

            scrollToTop && (scrollToTop.style.bottom = "5rem");
          }
          if (scrollToTop) {
            scrollToTop.style.setProperty("bottom", "6rem", "important");
          }
        } else if (jsdWidget && scrollToTop) {
          vorgangeListTable && (vorgangeListTable.style.marginBottom = "7rem");

          scrollToTop.style.bottom = "90px";
        }
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", handScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return visible ? (
    <button
      onClick={scrollToTop}
      id="scroll-to-top-button"
      className={scrollToTopButton}
      aria-label="Scroll to top"
    >
      ↑
    </button>
  ) : null;
};

export default ScrollToTopButton;
